/**
 * Design tokens for /carservice LP — Swiss, high-contrast light theme.
 * Exported as constants so any shared component (header, sticky CTA, footer)
 * can reuse without re-deriving color values.
 */

export const brand = {
  slate: "#1E293B",
  slateDeep: "#0F172A",
  accent: "#EA580C",       // blue-600 — primary CTA
  accentHover: "#C2410C",  // blue-700
  trustGreen: "#16A34A",
  bgPrimary: "#FFFFFF",
  bgSecondary: "#F8FAFC",  // slate-50
  bgTertiary: "#F1F5F9",   // slate-100
  textPrimary: "#0F172A",
  textSecondary: "#475569",
  textMuted: "#94A3B8",
  border: "#E2E8F0",       // slate-200
};

export const classes = {
  container: "max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-12",
  h1: "text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-extrabold text-slate-900 leading-[1.05]",
  h2: "text-3xl sm:text-4xl lg:text-5xl tracking-tight font-extrabold text-slate-900 leading-[1.1]",
  h3: "text-xl sm:text-2xl font-extrabold text-slate-900",
  overline: "text-xs font-extrabold uppercase tracking-[0.2em] text-blue-600",
  body: "text-base sm:text-lg text-slate-600 leading-relaxed",
  priceMono: "font-mono font-bold tracking-tight text-slate-900",
};

export const cdn = {
  heroImage:
    "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?auto=format&fit=crop&q=80&w=1600",
  mechanicHands:
    "https://images.unsplash.com/photo-1632823471565-1ecdf4a1e7f0?auto=format&fit=crop&q=80&w=1200",
};

const tokens = { brand, classes, cdn };
export default tokens;
